export default __webpack_public_path__ + "static/media/foodloft.cffdb597.jpeg";